import React from 'react';
import { useSite } from '@v2/shared/lib/site';
import useCurrentYear from '@v2/shared/lib/useCurrentYear';

type Props = {
  /** The year the server rendered — see `FullLayoutProps['copyrightYear']`. */
  year?: number;
};

/** headless: apps/topmags/layouts/MainLayout/Footer/SiteCopyright. */
export default function SiteCopyright({ year: initialYear }: Props) {
  const site = useSite();
  const year = useCurrentYear(initialYear);

  return (
    <p className="uppercase text-gray-500 tracking-widest text-xs text-center md:text-left mb-0 md:mb-3">
      Copyright &copy; {year} {site.name} &bull; United States &bull; All rights reserved
    </p>
  );
}
